module.exports = __webpack_public_path__ + "img/9_124.dd7babb3.png";